module.exports = __webpack_public_path__ + "img/Raspberry64_128.50c22c45.png";